export { default } from "./MobileStickyCta";
